module.exports = __webpack_public_path__ + "media/images/tl/banner/ko-light-pc-dbdfae66ce6daeaad73ab7c3426c1a26.jpg";